import React from "react";
import LightGrid from "./LightGrid";
import SideBar from "./SideBar";
import Hero from "./Hero";

export default class Home extends React.Component {

    render() {
        return (
            <div className="home-page-container">
                <Hero />
                <h1 className='home-section-header'>Latest Recipes</h1>
                <div className="home-container">
                    <LightGrid />
                    <SideBar />
                </div>
            </div>
        )
    }
}